<template>
  <div class='serviceSingleLabel'>
    <div class='serviceSingleLabel_body'
         v-if="!isEdit">
      <div class="tag_main">
        <el-tag v-for="tag in scope.row[tableData.bind]"
                size="mini"
                effect="dark"
                :key="tag.id"
                :disable-transitions="false">
          {{tag.name}}
        </el-tag>
      </div>
    </div>
    <el-select v-model="tagIdList"
               v-else
               multiple
               collapse-tags
               clearable
               size="mini"
               placeholder="请选择">
      <el-option v-for="item in options"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id">
      </el-option>
    </el-select>
    <div class='isEdit'>
      <ig-icon v-if="!isEdit "
               name="brush"
               @click="switchEdit"></ig-icon>
      <div v-else
           class="icon-list">
        <i class="el-icon-circle-check"
           @click="save"></i>
        <i class="el-icon-circle-close"
           @click="isEdit = false"></i>
      </div>
    </div>
  </div>
</template>

<script>
import customer from '@/backend/services/account/customer';
export default {
  name: 'serviceSingleLabel',
  props: {
    tableData: Object,
    scope: Object
  },
  data () {
    return {
      isEdit: false,
      options: [],
      tagIdList: [],
    }
  },
  watch: {
    'scope.row': {
      handler (val) {
        if (val[this.tableData.bind] && Array.isArray(val[this.tableData.bind])) {
          this.tagIdList = val[this.tableData.bind].map((tag) => {
            return tag.id
          })
        } else {
          this.tagIdList = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async switchEdit () {
      if (!this.getPermission(this.$permissionData.modifyAllServiceOrder.englishName) && !this.getPermission(this.$permissionData.serviceLabelEdit.englishName)) {
        this.$message.error('暂无权限');
        return
      }
      this.isEdit = !this.isEdit
      if (this.isEdit) {
        let { data } = await customer.serviceTagList()
        if (data) {
          this.options = data
        }
      }
    },
    async save () {
      let { scope, tagIdList, tableData } = this
      let { id } = scope.row
      await customer.addServiceTag({
        id,
        tagIdList
      })
      this.isEdit = false
      tableData.event()
    }
  }
}
</script>

<style lang='scss' scoped>
.serviceSingleLabel {
	display: flex;

	.serviceSingleLabel_body {
		.tag_main {
			.el-tag {
				margin-right: 5px;
			}
		}

		.el-select {
			width: 100%;
		}
	}

	.isEdit {
		margin-left: 2px;
		display: flex;
		align-items: center;

		i {
			cursor: pointer;
		}

		.iconfont {
			font-size: 18px;
			color: #409eff;
		}

		.icon-list {
			font-size: 18px;

			i {
				margin: 0 2px;
			}

			.el-icon-circle-check {
				color: #67c23a;
			}

			.el-icon-circle-close {
				color: #f56c6c;
			}
		}
	}
}
</style>
